<div class="col-21 fs-4"
     *iCms="'copy' of content; content: 'html'"></div>